// import React from "react";
// import "./Faculty.css";
// import teacher1 from "./images/school-img-8.jpeg";
// import teacher2 from "./images/school-img-6.jpeg";
// import teacher3 from "./images/FacultyImages/Ms. Nisha Sharma.png"; // Coordinator

// // Faculty Images
// import shabana from "./images/FacultyImages/Mrs. Shabana Khan.png";
// import sanjna from "./images/FacultyImages/Mrs. Sanjna Singh.png";
// import preeti1 from "./images/FacultyImages/Mrs. Preeti Thakur.png";
// import preeti3 from "./images/FacultyImages/Mrs. Preeti Thakur 3.png";
// import poonam from "./images/FacultyImages/Mrs. Poonam Thakur.png";
// import chanderkanta from "./images/FacultyImages/Ms. Chanderkanta.png";
// import geetika from "./images/FacultyImages/Ms. Geetika Dogra.png";
// import suman from "./images/FacultyImages/Ms. Suman Mehta.png";
// import suruchi from "./images/FacultyImages/Ms. Suruchi Sharma.png";
// import anjna from "./images/FacultyImages/Ms. Anjna Thakur.png";
// import asha from "./images/FacultyImages/Ms. Asha Sharma.png";
// import ranju from "./images/FacultyImages/Ms. Ranju Verma.png";
// import archana from "./images/FacultyImages/Ms. Archana.png";
// import geeta from "./images/FacultyImages/Ms. Geeta Sharma.png";
// import chanderprabha from "./images/FacultyImages/Ms. ChanderPrabha.png";
// import rishu from "./images/FacultyImages/Ms. Rishu Sharma.png";
// import nisha from "./images/FacultyImages/Mrs. Nisha Thakur.png";
// import ishani from "./images/FacultyImages/Ms. Ishani.png";
// import krishna from "./images/FacultyImages/Ms. Krishna Devi Thakur.png";
// import bhawna from "./images/FacultyImages/Ms. Bhawna Singh.png";
// import anita from "./images/FacultyImages/Ms. Anita Kumari.png";
// import neetu from "./images/FacultyImages/Ms. Neetu Kumari.png";
// import meenakshi from "./images/FacultyImages/Ms. Meenakshi Sood.png";
// import neelam from "./images/FacultyImages/Ms. Neelam Thakur.png";
// import admin from "./images/FacultyImages/Mrs. Reena Rawat.png"; // Admin Officer

// const Faculty = () => {
//   // Leadership including Admin Officer
//   const staffList = [
//     {
//       name: "Ms. Samiksha Chaudhary",
//       role: "Principal",
//       qualification: "B.A, B.Ed, L.LB",
//       description: "Provides visionary leadership and ensures holistic growth.",
//       img: teacher1,
//     },
//     {
//       name: "Mrs. Pooja Chaudhary",
//       role: "Vice Principal",
//       qualification: "M.A, B.Ed",
//       description: "Supports principal in academic & administrative duties.",
//       img: teacher2,
//     },
//     {
//       name: "Mrs. Nisha Sharma",
//       role: "Co-Ordinator",
//       qualification: "M.A,B.Ed, PDPET",
//       description: "Oversees smooth functioning of academic activities.",
//       img: teacher3,
//     },
//     {
//       name: "Mrs. Reena Rawat",
//       role: "Admin Officer",
//       qualification:
//         "M.A,Diploma in computer",
//       description:
//         "Handles administration, coordination, and office management tasks.",
//       img: admin,
//     },
//   ];

//   const teachingStaff = [
//     { name: "Shabana Khan", role: "TGT", qualification: "B.SC, B.ED, C.TET PDPET", subject: "English", img: shabana },
//     { name: "Sanjna Singh", role: "PRT", qualification: "M.A, B.ED, PDPET, TET", subject: "LKG - Mother Teacher", img: sanjna },
//     { name: "Preeti Thakur", role: "PRT", qualification: "M.com, B.ED, PDPET, NTT", subject: "English, EVS", img: preeti1 },
//     { name: "Preeti Thakur (3)", role: "PRT", qualification: "B.A, B.ED, PDPET, HPTET", subject: "Class-III Mother Teacher", img: preeti3 },
//     { name: "Poonam Thakur", role: "PRT", qualification: "M.A, B.ED, PDPET", subject: "Class-II Mother Teacher", img: poonam },
//     { name: "Chanderkanta", role: "Pre Primary Teacher", qualification: "M.A, NTT", subject: "Pre-Primary Mother Teacher", img: chanderkanta },
//     { name: "Geetika Dogra", role: "PRT", qualification: "B.A, M.A, B.ED,HPTET", subject: "EVS", img: geetika },
//     { name: "Suman Mehta", role: "TGT", qualification: "M.A, PTT, B.ED", subject: "Hindi", img: suman },
//     { name: "Suruchi Sharma", role: "TGT", qualification: "MSC, B.ED, PDPET", subject: "Maths", img: suruchi },
//     { name: "Anjna Thakur", role: "TGT", qualification: "M.A, B.ED, PDPET", subject: "Social Science", img: anjna },
//     { name: "Asha Sharma", role: "TGT", qualification: "BSC, B.ED, PDPET", subject: "Science", img: asha },
//     { name: "Ranju Verma", role: "PRT", qualification: "M.A, B.ED, PDPET", subject: "Pre-Primary Mother Teacher", img: ranju },
//     { name: "Archana", role: "GK Teacher", qualification: "B.A, Master in Journalism", subject: "GK Trainer", img: archana },
//     { name: "Geeta Sharma", role: "Music Teacher", qualification: "Diploma in Music, Sangeet Prabhakar", subject: "Music", img: geeta },
//     { name: "ChanderPrabha", role: "Librarian", qualification: "B.A, D.Lib, D.LIB", subject: "Librarian", img: chanderprabha },
//     { name: "Rishu Sharma", role: "Computer Teacher", qualification: "M.com, Computer Diploma", subject: "Computer", img: rishu },
//     { name: "Nisha Thakur", role: "PRT", qualification: "B.A, M.A, B.ED, HPTET", subject: "English", img: nisha },
//     { name: "Ishani", role: "Pre Primary Teacher", qualification: "M.com, NTT", subject: "UKG", img: ishani },
//     { name: "Krishna Devi Thakur", role: "Pre Primary Teacher", qualification: "B.A, M.A, PGDCA, TALLY, NTT", subject: "Nursery", img: krishna },
//     { name: "Bhawna Singh", role: "Pre Primary Teacher", qualification: "B.A, NTT, Computer Engineering", subject: "Class-I Mother Teacher", img: bhawna },
//     { name: "Anita Kumari", role: "Sports Teacher", qualification: "B.P.ed, M.P.ed", subject: "Sports", img: anita },
//     { name: "Neetu Kumari", role: "PRT", qualification: "B.Sc, M.A, B.Ed, CTET", subject: "Science", img: neetu },
//     { name: "Meenakshi Sood", role: "PRT", qualification: "B.A, M.A, NTT, B.Ed, HPTET", subject: "Class-I Mother Teacher", img: meenakshi },
//     { name: "Neelam Thakur", role: "PRT", qualification: "M.Sc, B.Ed, CTET", subject: "Maths", img: neelam },
//   ];

//   return (
//     <div className="faculty-container">
//       {/* Hero Section */}
//       <header className="faculty-hero">
//         <div className="hero-text">
//           <h1>Our Dedicated Faculty & Staff</h1>
//           <p>Passionate educators and coordinators shaping the school community</p>
//         </div>
//       </header>

//       {/* Leadership Cards */}
//       <div className="faculty-cards">
//         {staffList.map((staff, index) => (
//           <section key={index} className="principal-section animate-card">
//             <div
//               className={`principal-card ${
//                 staff.role === "Principal"
//                   ? "principal-bg"
//                   : staff.role === "Vice Principal"
//                   ? "vice-bg"
//                   : staff.role === "Co-Ordinator"
//                   ? "coordinator-bg"
//                   : "admin-bg"
//               }`}
//             >
//               <div className="principal-img">
//                 <img src={staff.img} alt={staff.name} className="faculty-img" />
//               </div>
//               <div className="principal-info">
//                 <h2>{staff.name}</h2>
//                 <p className="staff-role">{staff.role}</p>
//                 <p className="staff-qualification">{staff.qualification}</p>
//                 <p className="staff-description">{staff.description}</p>
//               </div>
//             </div>
//           </section>
//         ))}
//       </div>

//       {/* Teaching Staff */}
//       <h2 className="teaching-heading">Teaching Staff</h2>
//       <div className="teaching-grid">
//         {teachingStaff.map((staff, index) => (
//           <div key={index} className="teaching-card animate-card">
//             <img src={staff.img} alt={staff.name} />
//             <h3>{staff.name}</h3>
//             <p className="staff-role">{staff.role}</p>
//             <p className="staff-subject">{staff.subject}</p>
//             <p className="staff-qualification">{staff.qualification}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Faculty;
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Faculty.css";

const BASE_URL = "https://kkblossomschool.org/KKBlossomsWebsite/api.php";
const IMAGE_PATH = "https://kkblossomschool.org/KKBlossomsWebsite/uploads/FacultyImages/";

const Faculty = () => {
  const [faculty, setFaculty] = useState([]);
  const [leadership, setLeadership] = useState([]);
  const [teaching, setTeaching] = useState([]);
  const [loadedImages, setLoadedImages] = useState({});
  const handleImageLoad = (imageName) => {
  setLoadedImages((prev) => ({
    ...prev,
    [imageName]: true,
  }));
};
const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchFaculty();
  }, []);

  const fetchFaculty = async () => {
  try {
    setLoading(true);

    const res = await axios.get(`${BASE_URL}?action=getFaculty`);

    const data = Array.isArray(res.data) ? res.data : [];

    setFaculty(data);

    // Separate automatically
    setLeadership(data.filter((item) => item.type === "leadership"));
    setTeaching(data.filter((item) => item.type === "teaching"));
  } catch (err) {
    console.error("Error fetching faculty:", err);
  } finally {
    setLoading(false);
  }
};
if (loading) {
  return (
   <div className="awards-loader-wrapper">
        <svg
          role="img"
          aria-label="Loading"
          className="awards-smiley"
          viewBox="0 0 128 128"
        >
          <defs>
            <clipPath id="awards-smiley-eyes">
              <circle
                className="awards-smiley__eye1"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(-40,64,64) translate(0,-56)"
              />
              <circle
                className="awards-smiley__eye2"
                cx="64"
                cy="64"
                r="8"
                transform="rotate(40,64,64) translate(0,-56)"
              />
            </clipPath>

            <linearGradient
              id="awards-smiley-grad"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#000" />
              <stop offset="100%" stopColor="#fff" />
            </linearGradient>

            <mask id="awards-smiley-mask">
              <rect
                x="0"
                y="0"
                width="128"
                height="128"
                fill="url(#awards-smiley-grad)"
              />
            </mask>
          </defs>

          <g
            strokeLinecap="round"
            strokeWidth="12"
            strokeDasharray="175.93 351.86"
          >
            <g>
              <rect
                fill="hsl(207, 90%, 50%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(198, 83%, 60%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>

            <g mask="url(#awards-smiley-mask)">
              <rect
                fill="hsl(205, 86%, 62%)"
                width="128"
                height="64"
                clipPath="url(#awards-smiley-eyes)"
              />

              <g fill="none" stroke="hsl(197, 94%, 63%)">
                <circle
                  className="awards-smiley__mouth1"
                  cx="64"
                  cy="64"
                  r="56"
                  transform="rotate(180,64,64)"
                />

                <circle
                  className="awards-smiley__mouth2"
                  cx="64"
                  cy="64"
                  r="56"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
  );
}
  return (
    <div className="faculty-container">

      {/* Hero */}
      <header className="faculty-hero">
        <div className="hero-text">
          <h1>Our Dedicated Faculty & Staff</h1>
          <p>Passionate educators and coordinators shaping the school community</p>
        </div>
      </header>

      {/* Leadership */}
      <div className="faculty-cards">
        {leadership.map((staff, index) => (
         <section key={index} className="principal-section animate-card">
  <div
  className={`principal-card ${
    staff.role === "Principal/Director"
      ? "principal-bg"
      : staff.role === "Vice Principal"
      ? "vice-bg"
      : staff.role === "Co-Ordinator"
      ? "coordinator-bg"
      : "admin-bg"
  }`}
  data-role={staff.role}
>
              <div className="principal-img">
  {!loadedImages[staff.image] && (
    <div className="faculty-image-loader"></div>
  )}

  <img
    src={IMAGE_PATH + staff.image}
    alt={staff.name}
    className={`faculty-img ${
      loadedImages[staff.image] ? "loaded" : "loading"
    }`}
    onLoad={() => handleImageLoad(staff.image)}
  />
</div>

              <div className="principal-info">
                <h2>{staff.name}</h2>
                <p className="staff-role">{staff.role}</p>
                <p className="staff-qualification">{staff.qualification}</p>
                <p className="staff-description">{staff.description}</p>
              </div>
            </div>
          </section>
        ))}
      </div>

      {/* Teaching */}
      <h2 className="teaching-heading">Teaching Staff</h2>

      <div className="teaching-grid">
        {teaching.map((staff, index) => (
          <div key={index} className="teaching-card animate-card">
           <div className="teaching-image-wrapper">
  {!loadedImages[staff.image] && (
    <div className="faculty-image-loader"></div>
  )}

  <img
    src={IMAGE_PATH + staff.image}
    alt={staff.name}
    className={loadedImages[staff.image] ? "loaded" : "loading"}
    onLoad={() => handleImageLoad(staff.image)}
  />
</div>
            <h3>{staff.name}</h3>
            <p className="staff-role">{staff.role}</p>
            <p className="staff-subject">{staff.subject}</p>
            <p className="staff-qualification">{staff.qualification}</p>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Faculty;
